<div class="main-content">
  <!-- register.component.html -->
  <div id="biz-recaptcha-container"></div>

  <div class="register-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">Register as Vendor</h3>
    </div>

    <!-- STEP 1 -->
    <div *ngIf="step === 1" class="step-1">
      <h2 class="welcome-title">
        {{
          otpSent ? "Confirm your number" : "Welcome to the Aluguloo family!"
        }}
      </h2>

      <!-- MOBILE -->
      <form *ngIf="signupMethod === 'mobile'" #mobileForm="ngForm" class="form">
        <div class="phone-row mb-12">
          <!-- Country Code -->
          <div class="custom-input-box country-select">
            <mat-select
              [(ngModel)]="user.countryCode"
              name="countryCode"
              panelClass="wide-country-dropdown"
              disableOptionCentering
            >
              <mat-select-trigger>
                <div
                  class="flex-center"
                  *ngIf="getSelectedCountry() as selected"
                >
                  <img [src]="selected.flag" class="flag-icon-small" />
                  {{ selected.code }}
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let c of countryList" [value]="c.code">
                <img [src]="c.flag" class="flag-icon" /> {{ c.name }} ({{
                  c.code
                }})
              </mat-option>
            </mat-select>
          </div>

          <!-- Phone Number -->
          <div
            class="custom-input-box phone-input flex-1"
            [class.error]="submitted && !user.mobile"
          >
            <input
              type="text"
              [(ngModel)]="user.mobile"
              name="mobile"
              [maxlength]="currentPhoneLimit"
              (keypress)="numberOnly($event)"
              placeholder="Phone number *"
            />
          </div>
        </div>

        <button
          type="button"
          class="primary-cta"
          (click)="sendOtp()"
          *ngIf="!otpSent"
        >
          Get OTP
        </button>

        <div *ngIf="otpSent && !otpVerified" class="otp-block">
          <p
            class="otp-text"
            style="
              text-align: center;
              color: #666;
              font-size: 14px;
              margin-bottom: 24px;
            "
          >
            Enter the code we sent to {{ user.countryCode }} {{ user.mobile }}
          </p>

          <div class="otp-inputs">
            <input
              *ngFor="
                let digit of otpDigits;
                let i = index;
                trackBy: trackByIdx
              "
              type="tel"
              [id]="'otp-biz-' + i"
              maxlength="6"
              class="otp-box"
              [value]="otpDigits[i]"
              (input)="moveFocus($event, i)"
              (keydown)="handleBackspace($event, i)"
            />
          </div>

          <a
            class="resend-link"
            (click)="otpSent = false"
            style="
              text-align: center;
              display: block;
              margin-bottom: 16px;
              font-size: 13px;
              color: #555;
              text-decoration: underline;
              cursor: pointer;
            "
          >
            Choose another option to get the code
          </a>

          <button type="button" class="primary-cta" (click)="verifyOtp()">
            Verify OTP
          </button>
        </div>

        <button
          type="button"
          class="primary-cta"
          (click)="goToStep2()"
          *ngIf="otpVerified"
        >
          Continue
        </button>
      </form>

      <!-- EMAIL SIGNUP -->
      <form *ngIf="signupMethod === 'email'" #emailForm="ngForm" class="form">
        <!-- Email -->
        <div
          class="custom-input-box full-width mb-12"
          [class.error]="submitted && !user.emailid"
        >
          <input
            type="email"
            placeholder="Email ID *"
            [(ngModel)]="user.emailid"
            name="email"
            required
            email
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          />
        </div>

        <!-- Password -->
        <div
          class="custom-input-box full-width mb-12"
          [class.error]="submitted && !user.password"
        >
          <input
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="Password *"
            [(ngModel)]="user.password"
            name="password"
            required
          />
          <mat-icon class="eye-icon" (click)="hidePassword = !hidePassword">{{
            hidePassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </div>

        <!-- Confirm Password -->
        <div
          class="custom-input-box full-width mb-12"
          [class.error]="
            submitted && (!confirmPassword || confirmPassword !== user.password)
          "
        >
          <input
            [type]="hideConfirmPassword ? 'password' : 'text'"
            placeholder="Confirm Password *"
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            required
          />
          <mat-icon
            class="eye-icon"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            >{{
              hideConfirmPassword ? "visibility_off" : "visibility"
            }}</mat-icon
          >
        </div>

        <button
          type="button"
          class="primary-cta"
          (click)="validateEmailSignup()"
        >
          Register
        </button>
      </form>

      <!-- Social Options -->
      <div class="divider"><span>or</span></div>

      <div class="socials">
        <button type="button" class="social-button" (click)="googleSignup()">
          <img class="social-icon" src="assets/icons/google.png" alt="Google" />
          <span>Continue with Google</span>
        </button>

        <!-- <button type="button" class="social-button">
          <img class="social-icon" src="assets/icons/apple.png" alt="Apple" />
          <span>Continue with Apple</span>
        </button> -->

        <button
          type="button"
          class="social-button"
          (click)="
            switchSignupMethod(signupMethod === 'mobile' ? 'email' : 'mobile')
          "
        >
          <mat-icon class="social-icon" style="font-size: 18px">
            {{ signupMethod === "mobile" ? "mail" : "phone" }}
          </mat-icon>
          <span>{{
            signupMethod === "mobile"
              ? "Continue with Email"
              : "Continue with Mobile Number"
          }}</span>
        </button>
      </div>
    </div>

    <!-- STEP 2 -->
    <div *ngIf="step === 2" class="step-2">
      <h2 class="welcome-title smaller">Tell us more about your business.</h2>

      <form
        (ngSubmit)="submitHandler(form, $event)"
        #form="ngForm"
        class="form business-form"
      >
        <div
          class="custom-input-box full-width mb-12"
          [class.error]="submitted && !user.accountdetails.companyname"
        >
          <input
            type="text"
            [(ngModel)]="user.accountdetails.companyname"
            name="companyname"
            placeholder="Company Legal Name *"
            required
          />
        </div>

        <div
          class="custom-input-box full-width mb-12"
          [class.error]="submitted && !user.accountdetails.companyAddress"
        >
          <textarea
            [(ngModel)]="user.accountdetails.companyAddress"
            name="companyAddress"
            rows="1"
            placeholder="Company Address *"
            required
          ></textarea>
        </div>

        <!-- Company Logo Upload -->
        <div class="company-logo-wrapper">
          <div
            class="logo-preview"
            [style.backgroundImage]="getLogoStyle()"
          ></div>
          <input
            type="file"
            id="logoInput"
            (change)="onLogoSelected($event)"
            accept="image/*"
            hidden
          />
          <div class="logo-info">
            <p>Upload a clear PNG or JPG logo.</p>
            <div
              class="logo-actions"
              style="display: flex; gap: 10px; margin-top: 8px"
            >
              <button
                mat-stroked-button
                type="button"
                color="primary"
                (click)="triggerFileInput()"
                class="logo-btn"
              >
                <mat-icon>{{
                  user.accountdetails.companyLogoUrl ? "edit" : "upload"
                }}</mat-icon>
                {{
                  user.accountdetails.companyLogoUrl
                    ? "Edit Logo"
                    : "Upload Logo"
                }}
              </button>
            </div>
          </div>
        </div>

        <div class="phone-row mb-12">
          <!-- Business Phone -->
          <div class="phone-group">
            <div class="custom-input-box country-select">
              <mat-select
                [(ngModel)]="user.accountdetails.countryCode"
                name="countryCodeStep2"
                panelClass="wide-country-dropdown"
                disableOptionCentering
              >
                <mat-select-trigger>
                  <div
                    class="flex-center"
                    *ngIf="getSelectedCountry() as selected"
                  >
                    <img [src]="selected.flag" class="flag-icon-small" />
                    {{ selected.code }}
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let c of countryList" [value]="c.code">
                  <img [src]="c.flag" class="flag-icon" /> {{ c.name }} ({{
                    c.code
                  }})
                </mat-option>
              </mat-select>
            </div>

            <div
              class="custom-input-box phone-input flex-1"
              [class.error]="submitted && !user.accountdetails.phoneNumber"
            >
              <input
                type="text"
                [(ngModel)]="user.accountdetails.phoneNumber"
                name="phoneNumber"
                [maxlength]="currentPhoneLimit"
                (keypress)="numberOnly($event)"
                placeholder="Phone number *"
              />
            </div>
          </div>

          <!-- Telephone -->
          <div class="phone-group">
            <div class="custom-input-box country-select">
              <mat-select
                [(ngModel)]="user.accountdetails.telephoneCountryCode"
                name="telephoneCountryCode"
                panelClass="wide-country-dropdown"
                disableOptionCentering
              >
                <mat-select-trigger>
                  <div
                    class="flex-center"
                    *ngIf="getTelSelectedCountry() as selected"
                  >
                    <img [src]="selected.flag" class="flag-icon-small" />
                    {{ selected.code }}
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let c of countryList" [value]="c.code">
                  <img [src]="c.flag" class="flag-icon" /> {{ c.name }} ({{
                    c.code
                  }})
                </mat-option>
              </mat-select>
            </div>

            <div class="custom-input-box phone-input flex-1">
              <input
                type="text"
                [(ngModel)]="user.accountdetails.telephone"
                name="telephone"
                [maxlength]="currentTelLimit"
                (keypress)="numberOnly($event)"
                placeholder="Telephone"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="half-width mb-12">
            <div
              class="custom-input-box"
              [class.error]="submitted && !user.accountdetails.emailid"
            >
              <input
                type="email"
                [(ngModel)]="user.accountdetails.emailid"
                name="emailid"
                required
                email
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                placeholder="Email Id *"
              />
            </div>
            <div
              *ngIf="submitted && form.controls['emailid']?.invalid"
              style="color: red; font-size: 10px; margin-top: 4px"
            >
              <span *ngIf="form.controls['emailid']?.hasError('required')"
                >Email is required</span
              >
              <span
                *ngIf="
                  form.controls['emailid']?.hasError('pattern') ||
                  form.controls['emailid']?.hasError('email')
                "
              >
                Please enter a valid email address
              </span>
            </div>
          </div>

          <div
            class="custom-input-box half-width mb-12"
            [class.error]="submitted && !user.accountdetails.tradeLicenseNo"
          >
            <input
              type="text"
              [(ngModel)]="user.accountdetails.tradeLicenseNo"
              name="tradeLicenseNo"
              placeholder="Trade Licence No *"
              required
            />
          </div>
        </div>

        <div class="form-row" style="margin-bottom: 4px">
          <!-- LICENSE EXPIRY DATE (using Custom Calendar) -->
          <div style="position: relative; width: 100%; flex: 1" class="mb-12">
            <div
              class="custom-input-box"
              style="cursor: text"
              [class.error]="submitted && !user.accountdetails.expiryDate"
            >
              <input
                type="text"
                [(ngModel)]="expiryDisplay"
                name="expiryDate"
                (input)="onExpiryInput($event)"
                (focus)="showExpiryCalendar = true"
                (click)="$event.stopPropagation()"
                placeholder="License Expiry date * (DD/MM/YYYY)"
                required
              />
              <mat-icon
                class="suffix-icon"
                (click)="openExpiryCalendar($event)"
                style="cursor: pointer"
                >calendar_today</mat-icon
              >
            </div>

            <!-- Dropdown (Exact structure from SearchBarComponent) -->
            <!-- ... calendar code ... -->
          </div>

          <div
            class="custom-input-box half-width mb-12"
            [class.error]="submitted && !user.accountdetails.issuedBy"
          >
            <input
              type="text"
              [(ngModel)]="user.accountdetails.issuedBy"
              name="issuedBy"
              placeholder="License Issued by *"
              required
            />
          </div>
        </div>

        <div
          class="upload-wrapper"
          [class.error]="
            submitted && !user.accountdetails.companyDocuments?.length
          "
        >
          <input
            type="file"
            id="licenseFile"
            (change)="onFileSelected($event)"
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
            class="file-input"
          />
          <label for="licenseFile" class="upload-btn">
            {{
              user.accountdetails.companyDocuments?.length
                ? "Trade License Selected"
                : "Upload valid Trade License
            copy *"
            }}
            <small>PDF, JPG, JPEG, PNG, DOC up to 10MB</small>
          </label>

          <!-- Document Previews -->
          <div
            class="preview-mini-card-container"
            *ngIf="user.accountdetails.companyDocuments?.length"
          >
            <div
              class="template-mini-card"
              *ngFor="
                let doc of user.accountdetails.companyDocuments;
                let i = index
              "
            >
              <div class="mini-content" [class.uploading]="doc.uploading">
                <!-- Explicit Close Button -->
                <button
                  mat-icon-button
                  type="button"
                  class="remove-btn-absolute"
                  (click)="removeDocumentByIndex(i)"
                  matTooltip="Remove"
                >
                  <mat-icon>close</mat-icon>
                </button>

                <mat-progress-spinner
                  *ngIf="doc.uploading"
                  mode="indeterminate"
                  diameter="30"
                  class="upload-spinner"
                ></mat-progress-spinner>

                <!-- Image Preview -->
                <img
                  *ngIf="isImage(doc.name) && !doc.uploading"
                  [src]="doc.url"
                  alt="Preview"
                  class="preview-img"
                />

                <!-- PDF Preview -->
                <div
                  *ngIf="
                    !isImage(doc.name) && !isDoc(doc.name) && !doc.uploading
                  "
                  class="pdf-preview"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span>PDF Document</span>
                </div>

                <!-- DOC Preview -->
                <div
                  *ngIf="isDoc(doc.name) && !doc.uploading"
                  class="pdf-preview"
                >
                  <mat-icon>description</mat-icon>
                  <span>Word Document</span>
                </div>

                <!-- Action Buttons (Hover) -->
                <div class="card-actions" *ngIf="!doc.uploading">
                  <button
                    type="button"
                    mat-icon-button
                    class="action-btn view-btn"
                    matTooltip="View"
                    (click)="viewDocument(i)"
                    *ngIf="isImage(doc.name)"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <a
                    [href]="doc.url"
                    target="_blank"
                    mat-icon-button
                    class="action-btn view-btn"
                    matTooltip="View"
                    *ngIf="!isImage(doc.name)"
                  >
                    <mat-icon>visibility</mat-icon>
                  </a>
                </div>
              </div>
              <div class="template-name">{{ doc.name }}</div>
            </div>

            <!-- Add More Button -->
            <div class="add-more-wrapper">
              <input
                type="file"
                id="addMoreFilesVendor"
                (change)="onFileSelected($event)"
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                class="file-input"
              />
              <label
                for="addMoreFilesVendor"
                class="add-more-btn"
                matTooltip="Add more documents"
              >
                <mat-icon>add_circle</mat-icon>
                <span>Add more</span>
              </label>
            </div>
          </div>
        </div>

        <div
          class="terms-checkbox-wrapper"
          style="margin-bottom: 24px; text-align: center; margin-top: 10px"
        >
          <mat-checkbox
            name="termsAccepted"
            [checked]="termsAccepted"
            (change)="onTermsCheckboxChange($event)"
            [class.error]="submitted && !termsAccepted"
          >
            I agree to the
            <a
              href="javascript:void(0)"
              (click)="openTermsDialog($event)"
              style="color: #57c4ef; text-decoration: underline"
              >Terms and Conditions</a
            >
          </mat-checkbox>
          <div
            class="error-msg"
            *ngIf="submitted && !termsAccepted"
            style="color: red; font-size: 12px; margin-top: 4px"
          >
            You must accept the terms and conditions
          </div>
        </div>

        <button
          type="submit"
          class="primary-cta next-button"
          [disabled]="isSubmitting || !termsAccepted"
        >
          Next
        </button>
      </form>

      <p class="footer-text">All fields are mandatory.</p>
    </div>
  </div>
</div>
